/* eslint-disable indent */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { ConditionOperatorsEnum, SelectedFilter } from 'utils/filters';
import MultipleFilter from './MultipleFilter';
import SingleFilter from './SingleFilter';
import styles from './styles';

interface Props {
  selectedFilters: SelectedFilter[];
  onDeleteFilter: (filter: SelectedFilter) => void;
  onUpdateFilter: (filter: SelectedFilter) => void;
  onEnterPress: () => void;
}

const SelectedFilters = ({
  selectedFilters,
  onDeleteFilter,
  onUpdateFilter,
  onEnterPress,
}: Props) => {
  const classes = makeStyles(styles)();

  return (
    <Grid item className={classes.container}>
      {selectedFilters?.map(filter => (
        <Grid item key={filter.field} style={{ minWidth: 255 }}>
          {[ConditionOperatorsEnum.IS, ConditionOperatorsEnum.IS_NOT].includes(
            filter.operator
          ) && filter.multiple ? (
            <MultipleFilter
              filter={filter}
              onDeleteFilter={onDeleteFilter}
              onUpdateFilter={onUpdateFilter}
            />
          ) : (
            <SingleFilter
              filter={filter}
              onDeleteFilter={onDeleteFilter}
              onUpdateFilter={onUpdateFilter}
              onEnterPress={onEnterPress}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default SelectedFilters;
